

export default function LandingWorkflow() {
  return (
    <section className="lp-section lp-workflow-section" id="workflow" aria-labelledby="workflow-heading">
      <div className="lp-section-heading">
        <p className="lp-eyebrow">THE AUTOPROMOTE FLOW</p>
        <h2 id="workflow-heading">Make it yours.<br /><span>Then make it seen.</span></h2>
        <p>From the first upload to your next release.<br />Keep editing, saving and publishing in one workspace.</p>
      </div>
      <ol>
        <li>Import your footage and keep your original media.</li>
        <li>Edit in Studio, review AI Director suggestions or find clips.</li>
        <li>Save your project, export and prepare destination-specific posts.</li>
        <li>Review scheduled releases and delivery status in Queue.</li>
      </ol>
    </section>
  );
}
